var ObjectActionsType;
(function (ObjectActionsType) {
    ObjectActionsType["LOAD_STARTED"] = "LOAD_STARTED";
    ObjectActionsType["LOAD_FAILED"] = "LOAD_FAILED";
    ObjectActionsType["LOAD_SUCCESS"] = "LOAD_SUCCESS";
    ObjectActionsType["RELOAD_STARTED"] = "RELOAD_STARTED";
    ObjectActionsType["RELOAD_FAILED"] = "RELOAD_FAILED";
    ObjectActionsType["RELOAD_SUCCESS"] = "RELOAD_SUCCESS";
    ObjectActionsType["SAVE_STARTED"] = "SAVE_STARTED";
    ObjectActionsType["SAVE_FAILED"] = "SAVE_FAILED";
    ObjectActionsType["SAVE_SUCCESS"] = "SAVE_SUCCESS";
    ObjectActionsType["ELEMENT_UPDATED"] = "ELEMENT_UPDATED";
})(ObjectActionsType || (ObjectActionsType = {}));
export default ObjectActionsType;
//# sourceMappingURL=ObjectActionsType.js.map